import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { CONTACTS_PATH } from 'src/services/api/contacts/constants';

export const useDeleteContact = () => {
    const queryClient = useQueryClient();

    return useMutation<void, IStandardErrorResponse, number>(
        async (contactId) => {
            await apiClient(`${CONTACTS_PATH}/${contactId}`, { method: 'delete' });
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.contacts);
            }
        }
    );
};
